import type { Theme } from '@mui/material';

import type { Styles } from 'src/theme/themes';

export const styles = {
  errorSnackbarIcon: (theme: Theme) => ({
    borderRadius: '50%',
    bgcolor: theme.colors.error[500],
    width: '2.5rem',
    height: '2.5rem',
    color: theme.colors.white,
    justifyContent: 'center',
    flexDirection: 'column',

    svg: {
      margin: 'auto',
    },
  }),
} satisfies Styles;
